import Link from 'next/link'
import { Button, ButtonProps } from 'components/common/Button'
import { styled } from 'styles/styled'

interface LinkButtonProps extends ButtonProps {
  href: string
  passHref?: boolean
  isExternal?: boolean
  prefetch?: boolean
}

export const LinkButton = ({
  href,
  passHref,
  isExternal,
  prefetch = true,
  ...props
}: LinkButtonProps) => {
  return (
    <StyledLink
      prefetch={prefetch}
      href={href}
      passHref={passHref}
      $fullWidth={props.fullWidth}
      target={isExternal ? '_blank' : undefined}
      aria-label={props['aria-label']}
    >
      <Button {...props} />
    </StyledLink>
  )
}

export const StyledLink = styled(Link)<{ $fullWidth?: boolean }>`
  text-decoration: none;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
`
